export default __webpack_public_path__ + "static/media/DefaultDeviceImage.29235be2.png";